import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {alertTypes, useAlerts} from '../../ui/alert';

import {
  emCandidatosGetDuck,
  emCandidatosGetThunk,
  emCandidatoDeleteDuck,
  emCandidatoDeleteThunk,
  emCandidatoEditDuck,
  emCandidatoEditThunk,
  notaFavoritaGetDuck,
  notaFavoritaGetThunk,
} from '../duck';

import {
  constants,
  responseSelector,
  parseJwt,
  prepareDatosAuxOptions,
} from '../../utils/utils';

import {ListaEmCandidatosView} from './ListaEmCandidatosView';
import {useQueryParams} from '../../utils/useQueryParams';
import {emParametrosOptions} from '../../utils/constants';
import {getCargosDuck, getCargosThunk} from '../../oportunidades/duck';

const parametroOptionsToUse = [
  {value: null, label: 'Sin especificar'},
  ...emParametrosOptions,
];

const queryString = require('query-string');

function ListaEmCandidatos({history, match, test, token}) {
  const estudioMercadoIdNumerico = match.params.estudioMercadoIdNumerico;

  const {queryParams, queryParamsloaded} = useQueryParams(history);
  const dispatch = useDispatch();
  const {submitAlert, setTopAlert, topAlert} = useAlerts();

  const emCandidatosGet = useSelector(state => state.emCandidatosGet);
  const emCandidatoDelete = useSelector(state => state.emCandidatoDelete);
  const emCandidatoEdit = useSelector(state => state.emCandidatoEdit);
  const modelGetCargosPot = useSelector(state => state.getCargosPot);
  const modelCrearCargoPot = useSelector(state => state.crearCargoPot);
  const modelGetCargos = useSelector(state => state.getCargos);
  const notaFavoritaSet = useSelector(state => state.notaFavoritaSet);
  const notaFavoritaGet = useSelector(state => state.notaFavoritaGet);

  const [filters, setFilters] = useState({});
  const [totalResults, setTotalResults] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [busquedaRapida, setBusquedaRapida] = useState();
  const [groupedCandidates, setGroupedCandidates] = useState([]);
  const [selectedCandidato, setSelectedCandidato] = useState(null);
  const [candidatoSelectedForEdit, setCandidatoSelectedForEdit] =
    useState(null);
  const [condicionesActuales, setCondicionesActuales] = useState('');
  const [condicionesContratacion, setCondicionesContratacion] = useState('');
  const [resumen, setResumen] = useState('');

  // Parámetro del filtro
  const [filtroParametroOption, setFiltroParametroOption] = useState(null);

  // Parámetro del modal de edición de candidato
  const [parametroOption, setParametroOption] = useState([]);

  const [isModalNotasShown, setIsModalNotasShown] = useState();

  const [candidatoIdNumerico, setCandidatoIdNumerico] = useState();

  const [cargosOptions, setCargosOptions] = useState([]);
  const [cuentaFiltroChecked, setCuentaFiltroChecked] = useState(true);
  const [entrevistaCortesiaChecked, setEntrevistaCortesiaChecked] =
    useState(false);
  const [userIdNumerico, setUserIdNumerico] = useState();
  const [notaFavorita, setNotaFavorita] = useState(null);

  const [rubroOption, setRubroOption] = useState([]);

  const _getFiltersFromQueryParams = queryParams => {
    const page = parseInt(queryParams?.page ?? 1, 10);

    const busquedaRapida = queryParams?.busquedaRapida ?? '';

    return {
      busquedaRapida,
      page,
      rubrosIdsNumericos: queryParams?.rubrosIdsNumericos?.length
        ? queryParams.rubrosIdsNumericos
        : [],
      parametrosIds: queryParams?.parametrosIds || null,
    };
  };

  useEffect(() => {
    if (!queryParamsloaded) return;
    // Si no tenemos queryParams _getFiltersFromQueryParams
    // trae los filtros por defecto

    const filters = _getFiltersFromQueryParams(queryParams);

    setBusquedaRapida(filters.busquedaRapida);
    setPage(filters.page);

    setFilters(filters);
    getEmCandidatos(filters);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams]);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(emCandidatosGet);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(emCandidatosGetDuck.actions.clear());
    }

    if (data) {
      setGroupedCandidates(data.groupedItems);
      setTotalResults(data.total);

      dispatch(emCandidatosGetDuck.actions.clear());
    }
  }, [emCandidatosGet]);

  useEffect(() => {
    const {httpStatus, error, errorMessage} =
      responseSelector(emCandidatoDelete);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(emCandidatoDeleteDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      setSelectedCandidato(null);
      getEmCandidatos(filters);
      dispatch(emCandidatoDeleteDuck.actions.clear());
    }
  }, [emCandidatoDelete]);

  useEffect(() => {
    const {httpStatus, error, errorMessage} = responseSelector(emCandidatoEdit);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(emCandidatoEditDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      // setCandidatoSelectedForEdit(null);
      getEmCandidatos(filters);
      dispatch(emCandidatoEditDuck.actions.clear());
    }
  }, [emCandidatoEdit]);

  function getEmCandidatos(filters) {
    if (!filters) {
      throw new Error('No filters received');
    }

    dispatch(
      emCandidatosGetThunk({
        userToken: token.raw,
        limit: pageSize,
        estudioMercadoIdNumerico,
        page: filters.page,
        busquedaRapida: filters.busquedaRapida,
        rubrosIdsNumericos: filters.rubrosIdsNumericos,
        parametrosIds: filters.parametrosIds,
      }),
    );
  }

  function handlePage(page) {
    const strNewParams = queryString.stringify({
      estudioMercadoIdNumerico,
      limit: pageSize,
      page: page || 1,
      busquedaRapida,
      rubrosIdsNumericos: rubroOption?.map(elem => elem.value),
      parametrosIds: filtroParametroOption?.map(elem => elem.value),
    });

    history.replace(`${history.location.pathname}?${strNewParams}`);
  }

  const refetchCandidatos = () => {
    getEmCandidatos(filters);
  };

  function deleteEmCandidato(candidatoIdNumerico) {
    dispatch(
      emCandidatoDeleteThunk({
        userToken: token.raw,
        estudioMercadoIdNumerico,
        candidatoIdNumerico,
      }),
    );
  }

  function editEmCandidato() {
    const data = {
      userToken: token.raw,
      estudioMercadoIdNumerico,
      candidatoIdNumerico: candidatoSelectedForEdit.idNumerico,
      condicionesActuales,
      condicionesContratacion,
      resumen,
      parametro: parametroOption?.value,
    };

    dispatch(emCandidatoEditThunk(data));
  }

  useEffect(() => {
    if (candidatoSelectedForEdit) {
      setCondicionesActuales(candidatoSelectedForEdit.condicionesActuales);
      setCondicionesContratacion(
        candidatoSelectedForEdit.condicionesContratacion,
      );
      setResumen(candidatoSelectedForEdit.resumen);
      if (candidatoSelectedForEdit.parametro) {
        setParametroOption(
          parametroOptionsToUse.find(
            option => option.value === candidatoSelectedForEdit.parametro,
          ),
        );
      } else {
        setParametroOption({value: null, label: 'Sin especificar'});
      }
    }
  }, [candidatoSelectedForEdit]);

  const hideModalNotas = () => {
    setCandidatoIdNumerico(null);
    setIsModalNotasShown(false);
  };
  const showModalNotas = () => {
    setIsModalNotasShown(true);
  };

  useEffect(() => {
    if (token?.raw) {
      const decodedToken = parseJwt(token.raw);
      setUserIdNumerico(decodedToken?.idNumerico);
    }
  }, [token]);

  useEffect(() => {
    dispatch(
      getCargosThunk({
        userToken: token.raw,
      }),
    );
  }, []);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(modelGetCargos);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getCargosDuck.actions.clear());
    }

    if (data) {
      const cargos = data.items;

      const datosAuxOptions = prepareDatosAuxOptions(cargos);

      setCargosOptions(datosAuxOptions);

      dispatch(getCargosDuck.actions.clear());
    }
  }, [modelGetCargos]);

  useEffect(() => {
    const {httpStatus, data, error, errorMessage} =
      responseSelector(notaFavoritaGet);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(notaFavoritaGetDuck.actions.clear());
    }

    if (httpStatus === 200) {
      setNotaFavorita(data);

      dispatch(notaFavoritaGetDuck.actions.clear());
    }
  }, [notaFavoritaGet]);

  function getNotaFavorita() {
    dispatch(
      notaFavoritaGetThunk({
        userToken: token.raw,
        candidatoIdNumerico: candidatoSelectedForEdit.idNumerico,
      }),
    );
  }

  useEffect(() => {
    if (candidatoSelectedForEdit) {
      getNotaFavorita();
    }
  }, [candidatoSelectedForEdit]);

  return (
    <ListaEmCandidatosView
      history={history}
      topAlert={topAlert}
      submitAlert={submitAlert}
      totalResults={totalResults}
      page={page}
      pageSize={pageSize}
      handlePage={handlePage}
      refetchCandidatos={refetchCandidatos}
      busquedaRapida={busquedaRapida}
      setBusquedaRapida={setBusquedaRapida}
      emCandidatosGet={emCandidatosGet}
      groupedCandidates={groupedCandidates}
      emCandidatoDelete={emCandidatoDelete}
      deleteEmCandidato={deleteEmCandidato}
      selectedCandidato={selectedCandidato}
      setSelectedCandidato={setSelectedCandidato}
      candidatoSelectedForEdit={candidatoSelectedForEdit}
      setCandidatoSelectedForEdit={setCandidatoSelectedForEdit}
      emCandidatoEdit={emCandidatoEdit}
      editEmCandidato={editEmCandidato}
      parametroOption={parametroOption}
      parametroOptions={parametroOptionsToUse}
      setParametroOption={setParametroOption}
      condicionesActuales={condicionesActuales}
      setCondicionesActuales={setCondicionesActuales}
      condicionesContratacion={condicionesContratacion}
      setCondicionesContratacion={setCondicionesContratacion}
      resumen={resumen}
      setResumen={setResumen}
      candidatoIdNumerico={candidatoIdNumerico}
      isModalNotasShown={isModalNotasShown}
      hideModalNotas={hideModalNotas}
      showModalNotas={showModalNotas}
      userIdNumerico={userIdNumerico}
      cuentaFiltroChecked={cuentaFiltroChecked}
      setCuentaFiltroChecked={setCuentaFiltroChecked}
      entrevistaCortesiaChecked={entrevistaCortesiaChecked}
      setEntrevistaCortesiaChecked={setEntrevistaCortesiaChecked}
      modelGetCargosPot={modelGetCargosPot}
      modelCrearCargoPot={modelCrearCargoPot}
      cargosOptions={cargosOptions}
      notaFavoritaSet={notaFavoritaSet}
      setCandidatoIdNumerico={setCandidatoIdNumerico}
      notaFavorita={notaFavorita}
      notaFavoritaGet={notaFavoritaGet}
      token={token}
      estudioMercadoIdNumerico={estudioMercadoIdNumerico}
      queryParams={queryParams}
      getNotaFavorita={getNotaFavorita}
      rubroOption={rubroOption}
      setRubroOption={setRubroOption}
      filtroParametroOption={filtroParametroOption}
      setFiltroParametroOption={setFiltroParametroOption}
    />
  );
}

export {ListaEmCandidatos};
